import '@fontsource-variable/bricolage-grotesque';
import '@fontsource-variable/figtree';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import './ui/core/theme.css';

const root = createRoot(document.getElementById('root')!);

// The public demo (talkos.lt → app.talkos.lt/demo) is the same app against a made-up organization in the
// page. Its code loads only there, so the real app's bundle stays as it is.
if (/^\/demo(\/|$)/.test(location.pathname)) {
  void import('./demo/boot').then((demo) => demo.boot(root));
} else {
  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
